/* GRIG Shopify theme JS — AJAX cart, free-ship progress, reveal, consent/tracking scaffold */
(function(){
  var $ = function(s,r){return (r||document).querySelector(s);};
  var FREE = window.GRIG_FREE_SHIPPING || 35000;
  var FMT  = window.GRIG_MONEY_FORMAT || '{{amount}} Kč';

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(cents){
    var v = (cents/100).toLocaleString('cs-CZ',{minimumFractionDigits:0,maximumFractionDigits:2});
    return FMT.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* header shrink */
  var hdr = $('#hdr');
  addEventListener('scroll', function(){ if(hdr) hdr.classList.toggle('scrolled', scrollY>16); }, {passive:true});

  /* scroll reveal */
  var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el,i){el.style.transitionDelay=(i%4*60)+'ms';io.observe(el);});

  /* toast */
  var tT; function toast(m){var t=$('#toast');if(!t)return;$('#toastTxt').innerHTML=m;t.classList.add('show');clearTimeout(tT);tT=setTimeout(function(){t.classList.remove('show');},2200);}

  /* cart drawer */
  var drawer=$('#drawer'), scrim=$('#scrim');
  function openCart(o){if(drawer)drawer.classList.toggle('open',o);if(scrim)scrim.classList.toggle('open',o);}
  if($('#cartBtn')) $('#cartBtn').onclick=function(){openCart(true);refreshCart();};
  if($('#closeCart')) $('#closeCart').onclick=function(){openCart(false);};
  if(scrim) scrim.onclick=function(){openCart(false);};

  function refreshCart(){
    fetch((window.GRIG_ROUTES&&window.GRIG_ROUTES.cart||'/cart')+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      if($('#cnt')) $('#cnt').textContent=c.item_count;
      if($('#dtot')) $('#dtot').textContent=money(c.total_price);
      var di=$('#ditems');
      if(di) di.innerHTML = c.items.length ? c.items.map(function(i){
        return '<div class="ditem"><span style="display:flex;align-items:center;gap:10px">'+(i.featured_image&&i.featured_image.url?'<img src="'+esc(i.featured_image.url)+'" alt="'+esc(i.product_title)+'" width="48" height="48" style="border-radius:8px;object-fit:cover;flex-shrink:0">':'')+'<span>'+esc(i.product_title)+(i.variant_title&&i.variant_title!=='Default Title'?'<br><small style="color:var(--muted)">'+esc(i.variant_title)+'</small>':'')+'</span><span style="display:flex;align-items:center;gap:4px;margin-left:4px"><button type="button" style="background:none;border:1px solid var(--line);color:var(--ink);width:22px;height:22px;border-radius:6px;cursor:pointer;font-size:14px;line-height:1;padding:0" onclick="fetch(window.GRIG_ROUTES.change+\'.js\',{method:\'POST\',headers:{\'Content-Type\':\'application/json\'},body:JSON.stringify({id:\''+i.key+'\',quantity:'+(i.quantity-1)+'})}).then(function(){window.refreshCart();})">−</button><span style="min-width:18px;text-align:center">'+i.quantity+'</span><button type="button" style="background:none;border:1px solid var(--line);color:var(--ink);width:22px;height:22px;border-radius:6px;cursor:pointer;font-size:14px;line-height:1;padding:0" onclick="fetch(window.GRIG_ROUTES.change+\'.js\',{method:\'POST\',headers:{\'Content-Type\':\'application/json\'},body:JSON.stringify({id:\''+i.key+'\',quantity:'+(i.quantity+1)+'})}).then(function(){window.refreshCart();})">+</button></span></span><span style="display:flex;align-items:center;gap:8px"><span class="p">'+money(i.line_price)+'</span><button type="button" aria-label="Remove" style="background:none;border:none;cursor:pointer;color:var(--muted);font-size:26px;line-height:1;padding:0;opacity:.6;transition:opacity .2s" onmouseover="this.style.opacity=\'1\'" onmouseout="this.style.opacity=\'.6\'" onclick="fetch(window.GRIG_ROUTES.change+\'.js\',{method:\'POST\',headers:{\'Content-Type\':\'application/json\'},body:JSON.stringify({id:\''+i.key+'\',quantity:0})}).then(function(){window.refreshCart();})">×</button></span></div>';

      }).join('') : '<div class="dempty">'+((window.GRIG_I18N&&window.GRIG_I18N.empty)||'Your cart is empty.')+'</div>';
      var pct=Math.min(c.total_price/FREE*100,100);
      if($('#shipBar')) $('#shipBar').style.width=pct+'%';
      if($('#shipTxt')) $('#shipTxt').innerHTML = c.total_price>=FREE ? ((window.GRIG_I18N&&window.GRIG_I18N.freeship)||"You've got free shipping! 🎉") : (((window.GRIG_I18N&&window.GRIG_I18N.shipmore)||'Add {amt} more for free shipping 🚚').replace('{amt}','<b>'+money(FREE-c.total_price)+'</b>'));
    });
  }
  window.refreshCart = refreshCart;

  /* AJAX add to cart: forms with [data-grig-add] or buttons posting variant id */
  document.addEventListener('submit', function(e){
    var f=e.target.closest('form[data-grig-add]'); if(!f) return;
    e.preventDefault();
    var fd=new FormData(f);
    fetch((window.GRIG_ROUTES&&window.GRIG_ROUTES.add||'/cart/add')+'.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){return r.json();})
      .then(function(item){
        toast(((window.GRIG_I18N&&window.GRIG_I18N.added)||'Added:')+' <b>'+esc(item.product_title||'item')+'</b>');
        if(window.trackAddToCart) trackAddToCart(item.product_title, (item.price||0)/100, item.product_id);
        refreshCart(); openCart(true);
      }).catch(function(){ toast((window.GRIG_I18N&&window.GRIG_I18N.err)||'Could not add to cart'); });
  });

  refreshCart();

  /* ===== Souhlas s cookies: kategorie + Consent Mode v2 + Shopify Customer Privacy API ===== */
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){ dataLayer.push(arguments); };
  var IDS = window.GRIG_IDS || {};
  var CUR = window.GRIG_CURRENCY || 'EUR';
  var KEY = 'grig_consent_v2';
  var MAXAGE = 365 * 864e5;   /* souhlas se po roce znovu zeptá */

  gtag('consent','default',{ad_storage:'denied',analytics_storage:'denied',
    ad_user_data:'denied',ad_personalization:'denied',functionality_storage:'granted',
    security_storage:'granted'});

  function set(v){ return v && String(v).indexOf('XXX') === -1 && String(v).trim() !== ''; }

  function loadAnalytics(){
    if(!set(IDS.ga4) || window.__grigGA) return; window.__grigGA = 1;
    var s = document.createElement('script'); s.async = 1;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + IDS.ga4;
    document.head.appendChild(s);
    gtag('js', new Date()); gtag('config', IDS.ga4);
  }
  function loadMarketing(){
    if(set(IDS.metaPixel) && !window.__grigFB){ window.__grigFB = 1;
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
      s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', IDS.metaPixel); fbq('track','PageView');
    }
  }

  function apply(a, m){
    gtag('consent','update',{
      analytics_storage: a ? 'granted' : 'denied',
      ad_storage:        m ? 'granted' : 'denied',
      ad_user_data:      m ? 'granted' : 'denied',
      ad_personalization:m ? 'granted' : 'denied'
    });
    /* Shopify vlastní měření a aplikační pixely se řídí tímhle, ne naším gtagem */
    try {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(err){
          if (err || !Shopify.customerPrivacy) return;
          Shopify.customerPrivacy.setTrackingConsent(
            {analytics: !!a, marketing: !!m, preferences: !!a, sale_of_data: !!m},
            function(){}
          );
        });
      }
    } catch(e){}
    if (a) loadAnalytics();
    if (m) loadMarketing();
  }

  function load(){
    try { var o = JSON.parse(localStorage.getItem(KEY));
      if (!o || !o.t || (Date.now() - o.t) > MAXAGE) return null; return o;
    } catch(e){ return null; }
  }
  function save(a, m){
    try { localStorage.setItem(KEY, JSON.stringify({a:!!a, m:!!m, t:Date.now()})); } catch(e){}
    apply(a, m);
  }

  var box = $('#consent'), opts = $('#ckOptions'), btnSave = $('#ckSave'), btnCust = $('#ckCustomise');
  function show(){ if(box) box.style.display = 'block'; }
  function hide(){ if(box) box.style.display = 'none'; }

  var saved = load();
  if (saved) { apply(saved.a, saved.m); } else { show(); }

  if (box) {
    var cA = $('#ck-analytics'), cM = $('#ck-marketing');
    $('#ckAccept').onclick = function(){ save(true, true); hide(); };
    $('#ckReject').onclick = function(){ save(false, false); hide(); };
    if (btnCust) btnCust.onclick = function(){
      opts.style.display = 'block'; btnCust.style.display = 'none'; btnSave.style.display = 'block';
    };
    if (btnSave) btnSave.onclick = function(){
      save(cA && cA.checked, cM && cM.checked); hide();
    };
  }
  var reopen = $('#ckReopen');
  if (reopen) reopen.onclick = function(ev){
    ev.preventDefault();
    var s = load(); var cA = $('#ck-analytics'), cM = $('#ck-marketing');
    if (s) { if(cA) cA.checked = !!s.a; if(cM) cM.checked = !!s.m; }
    if (opts) opts.style.display = 'block';
    if (btnCust) btnCust.style.display = 'none';
    if (btnSave) btnSave.style.display = 'block';
    show();
  };

  window.trackAddToCart = function(name, value, id){
    dataLayer.push({event:'add_to_cart', ecommerce:{currency:CUR, value:value,
      items:[{item_name:name, item_id:id, price:value}]}});
    if (window.fbq) fbq('track','AddToCart',{content_name:name, value:value, currency:CUR});
  };

    /* hamburger */
  var hbg = document.getElementById('hamburger');
  var mob = document.getElementById('mobileMenu');
  if (hbg && mob) {
    hbg.addEventListener('click', function() {
      var open = mob.classList.toggle('open');
      hbg.classList.toggle('open', open);
      hbg.setAttribute('aria-expanded', open);
    });
    mob.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mob.classList.remove('open');
        hbg.classList.remove('open');
        hbg.setAttribute('aria-expanded', false);
      });
    });
  }
  var closeBtn = document.getElementById('mobileClose');
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    mob.classList.remove('open');
    hbg.classList.remove('open');
    hbg.setAttribute('aria-expanded', false);
  });
}


})();

